import { useState, useEffect, useRef } from "react";
import TransactionsList from "./Transactions/TransactionsList";
import Layout from "../Shared/Layout";
import TransactionForm from "./Transactions/TransactionForm/TransactionForm";

const TransactionsPageAdmin = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const modalRef = useRef(null);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        // Fermer le modal Bootstrap manuellement
        if (modalRef.current) {
            const modal = window.bootstrap.Modal.getInstance(modalRef.current);
            if (modal) {
                modal.hide();
            }
        }
    };

    // Effet pour gérer le modal Bootstrap
    useEffect(() => {
        if (modalRef.current) {
            const modalElement = modalRef.current;
            
            if (isModalOpen) {
                const modal = new window.bootstrap.Modal(modalElement);
                modal.show();
                
                // Écouter la fermeture du modal
                const handleHidden = () => {
                    setIsModalOpen(false);
                };
                
                modalElement.addEventListener('hidden.bs.modal', handleHidden);
                
                // Nettoyage
                return () => {
                    modalElement.removeEventListener('hidden.bs.modal', handleHidden);
                };
            }
        }
    }, [isModalOpen]);

    return (
        <>
            <Layout>
                <div className="content-body default-height">
                    <div className="container-fluid"> 
                        <div className="row">
                            <TransactionsList onOpenModal={handleOpenModal} />
                            
                            {/* Modal Bootstrap - CORRIGER L'ID */}
                            <div 
                                ref={modalRef}
                                className="modal fade" 
                                id="transactionModal" // CHANGER ICI - doit correspondre partout
                                tabIndex="-1" 
                                aria-labelledby="transactionModalLabel" 
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <TransactionForm 
                                            closeModal={handleCloseModal}
                                            key={isModalOpen ? 'open' : 'closed'} // Force le remontage
                                        />
                                    </div>
                                </div>
                            </div>   
                        </div> 
                    </div>
                </div> 
            </Layout> 
        </>
    );
}

export default TransactionsPageAdmin;